import { SET_ERROR, CLEAR_ERROR
} from '../../constants/actionTypes';

export const errorReducer = (state = {}, action) => {
  const {type, payload} = action;
  switch (type) {
    case SET_ERROR:
      return payload
    case CLEAR_ERROR:
      return {}
    default:
      return {}
  }
}